import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';

export const getCardAnimation = (idx: number, idx2?: number) => {
    if (isH5HandleClient()) {
        if (idx2) {
            return `${0.25 + 0.125 * (idx + idx2)}s forwards cardEnter`;
        }
        return `${0.25 + 0.125 * idx}s forwards cardEnter`;
    }
    return `${0.7 + 0.125 * idx}s forwards cardEnter`;
};

export const getTarget = (href?: string) => {
    if (href?.includes('www.ecoflow.com')) {
        return '_self';
    }
    return '_blank';
};
